// src/MeuComponente.js
import React, { useEffect, useState } from 'react';
import { SearchBar, Page } from 'components';
import Results from './components/Results';

import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import { loadState, saveState } from 'utils/persistState';
import ApiTcpServer from 'services/ApiTcpServer';
import ApiGServer from 'services/ApiGServer';
import { useAppTheme } from '../../contexts/ThemeContext';

const SuporteIot = () => {
  const user = JSON.parse(localStorage.getItem('userData'))
  if (user?.permission?.supportiot?.read !== true) {
    window.location.replace('/home');
  }

  // Removidos: filterEquipaments, allEquipaments
  const [filterUnits, setFilterUnits] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:supportiot';

  const currentTheme = useAppTheme();

  // Load persisted filter on mount
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist filter when it changes
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let { data } = await ApiTcpServer.get('/api/equipamentos');
        if (data.length === 0) {
          setLoading(false);
          return;
        }

        // Guardar os dados da primeira API para mesclar depois
        const equipmentStatusMap = {};
        data.forEach(item => {
          equipmentStatusMap[item.serial] = {
            sts: item.sts,
            err: item.err,
            lastUpdate: item.lastUpdate
          };
        });

        const serials = data
          .map(item => item.serial)
          .sort((a, b) => a.localeCompare(b));

        handleDetailEquipaments(serials, equipmentStatusMap);
      } catch (error) {
        console.log(error?.message);
        setLoading(false);
      }
    };

    fetchData();
    setPermission(user?.permission?.supportiot);

    // Configura o intervalo para rodar a cada 1 minuto
    const interval = setInterval(() => {
      // Só roda se searchData estiver vazio
      if (searchData === '') {
        fetchData();
      }
    }, 20000);

    // Limpa o intervalo quando o componente desmontar
    return () => clearInterval(interval);

  }, []);

  const handleDetailEquipaments = async (equipments, statusMap) => {
    try {
      const { data } = await ApiGServer.post(`/equipment/filter`, { filter: equipments });

      // Mesclar dados das duas APIs
      const mergedData = data.map(item => {
        const serial = item.serialnumber || item.serial;
        const statusData = statusMap[serial] || {};

        return {
          ...item,
          serial: serial,
          sts: statusData.sts,
          err: statusData.err,
          lastUpdate: statusData.lastUpdate
        };
      });

      setFilterUnits(mergedData);
      setAllUnits(mergedData);
    } catch (error) {
      console.log(error?.message);
    } finally {
      setLoading(false);
    }
  };


  const handleSearch = () => {
    if (searchData === '') {
      setAllUnits(filterUnits);
    } else {
      const equipamentsSearch = [];
      filterUnits.forEach((item) => {
        if (
          (item?.serial?.toLowerCase().includes(searchData.toLowerCase())) ||
          (item?.company?.name?.toLowerCase().includes(searchData.toLowerCase())) ||
          (item?.company_id?.toLowerCase().includes(searchData.toLowerCase()))
        ) { equipamentsSearch.push(item) }
      });

      setAllUnits(equipamentsSearch);
    }
  };

  // Auto-apply filter when data or search changes
  useEffect(() => {
    handleSearch();
  }, [filterUnits, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  return (
    <Page className="p-3" title="Suporte Iot">
      <Header page={"Suporte Iot"} />

      {loading && <Reload />}

      <SearchBar
        onSearch={handleSearch}
        onSearchData={handleSearchData}
        searchData={searchData}
      />

      {allUnits && (
        <Results
          data={allUnits}
          permission={permission}
          currentTheme={currentTheme}
        />
      )}
    </Page >
  );
}

export default SuporteIot;
